// import 'bootstrap/dist/css/bootstrap.css';
import './common/styles/reset.css';


import './styles.css';
import './common/assets/libs/details-polyfill/details-polyfill-ie-fix.css';

import './common/variables.css';
import './common/modules/account-empty-text/account-empty-text.css';
import './common/modules/add-commodity-offer/add-commodity-offer.css';
import './common/modules/add-commodity-offer-form/add-commodity-offer-form.css';
import './common/modules/add-offer/add-offer.css';
import './common/modules/add-product/add-product.css';
import './common/modules/account-message/account-message.css';
import './common/modules/article-lead/article-lead.css';
import './common/modules/article-sidebar/article-sidebar.css';
import './common/modules/banners/banners.css';
import './common/modules/block-title/block-title.css';
import './common/modules/breadcrumbs/breadcrumbs.css';
import './common/modules/btn-account/btn-account.css';
import './common/modules/btn-back/btn-back.css';
import './common/modules/btn-call/btn-call.css';
import './common/modules/btn-cart/btn-cart.css';
import './common/modules/btn-checkout/btn-checkout.css';
import './common/modules/btn-index/btn-index.css';
import './common/modules/btn-main/btn-main.css';
import './common/modules/btn-map/btn-map.css';
import './common/modules/btn-more/btn-more.css';
import './common/modules/calendar/calendar.css';
import './common/modules/calendar/pickmeup.css';
import './common/modules/catalog-card/catalog-card.css';
import './common/modules/catalog-search-filter/catalog-search-filter.css';
import './common/modules/catalog-navigation/catalog-navigation.css';
import './common/modules/catalog-product/catalog-product.css';
import './common/modules/catalog-table/catalog-table.css';
import './common/modules/catalog-reviews/catalog-reviews.css';
import './common/modules/category-prod/category-prod.css';
import './common/modules/commodity/commodity.css';
import './common/modules/checkbox/checkobox.css';
import './common/modules/data-sorter/data-sorter.css';
import './common/modules/empty-result/empty-result.css';
import './common/modules/error-message/error-message.css';
import './common/modules/footer/footer.css';
import './common/modules/form-about-company/form-about-company.css';
import './common/modules/form-ask-for-call/form-ask-for-call.css';
import './common/modules/form-search/form-search.css';
import './common/modules/forms-account/forms-account.css';
import './common/modules/group-actions/group-actions.css';
import './common/modules/header/header.css';
import './common/modules/input/input.css';
import './common/modules/lessor-catalog/lessor-catalog.css';
import './common/modules/modal/modal.css';
import './common/modules/tooltip/tooltip.css';
import './common/modules/navigation-account/navigation-account.css';
import './common/modules/navigation-account-login/navigation-account-login.css';
import './common/modules/navigation-global/navigation-global.css';
import './common/modules/nice-select/nice-select.css';
import './common/modules/offers-index/offers-index.css';
import './common/modules/page-title/page-title.css';
import './common/modules/payments-history/payments-history.css';
import './common/modules/preloader-overlay/preloader-overlay.css';
import './common/modules/product-description/product-description.css';
import './common/modules/product-offers/product-offers.css';
import './common/modules/product-specifications/product-specifications.css';
import './common/modules/radio-button/radio-button.css';
import './common/modules/rent-point-view/rent-point-view.css';
import './common/modules/scrollbar-custom/scrollbar-custom.css';
import './common/modules/select/select.css';
import './common/modules/select-custom/select-custom.css';
import './common/modules/star-rating-static/star-rating-static.css';
import './common/modules/tag-cloud/tag-cloud.css';
import './common/modules/text-field/text-field.css';
import './common/modules/search-area/search-area.css';
import './common/modules/received-order/received-order.css';
import './common/modules/cart-item/cart-item.css';
import './common/modules/cart-error/cart-error.css';
import './common/modules/wysiwyg/wysiwyg.css';
import './common/modules/form-search/form-search.css';
import './common/modules/map-for-catalog/map-for-catalog.css';
import './common/modules/timesheet/timesheet.css';
import './common/modules/received-order/received-order.css';
import './common/modules/type-order/type-order.css';
import './common/modules/orders-sort/orders-sort.css';
import './common/modules/preloader/md-preloader.min.css';
import './common/modules/time/time.css';
import './common/modules/form-edit-email/edit-email.css';
// import './common/modules/account-search/account-search.css';

import './common/modules/cart-contact/cart-contact.css';

import './pages/account-rent-points-create/account-rent-points-create.css';
import './pages/article/article.css';
import './pages/articles/articles.css';
import './pages/catalog-categories/catalog-categories.css';
import './pages/error/error.css';
import './pages/account-message-success/account-message-success.css';
//import './pages/index/index.css';
import './pages/uikit/uikit.css';
import './pages/cart/cart.css';
import './common/modules/mobile-header/mobile-header.css';
import './common/modules/mobile-menu/mobile-menu.css';
import './common/modules/mobile-location/mobile-location.css';
import './common/modules/mobile-category/mobile-category.css';
import './common/modules/mobile-menu/mobile-menu.css';
import './common/modules/mobile-search/mobile-search.css';


// WEBPACK FOOTER //
// ./src/styles.js